module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pivot-offer': _vm.isPivot
    }
  }, [(_vm.getOfferSellerName) ? _c('span', {
    staticClass: "no-wrap seller-name"
  }, [_vm._v("(" + _vm._s(_vm.getOfferSellerName) + ")")]) : _vm._e(), _vm._v(" "), (_vm.getOfferParentLink) ? _c('a', {
    attrs: {
      "href": _vm.getOfferParentLink,
      "target": "_blank",
      "rel": "noreferrer"
    }
  }, [_c('span', {
    staticClass: "no-wrap"
  }, [_vm._v(_vm._s(_vm.getOfferShopName))])]) : _c('span', {
    staticClass: "no-wrap"
  }, [_vm._v(_vm._s(_vm.getOfferShopName))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isOfferBestseller) ? _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t('Bestseller')),
      expression: "t('Bestseller')",
      arg: "tooltip"
    }],
    staticClass: "offer-component icon icon-detail icon-bestseller"
  }) : _vm._e(), _vm._v(" "), (_vm.isNewOffer) ? _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t('New offer')),
      expression: "t('New offer')",
      arg: "tooltip"
    }],
    staticClass: "offer-component icon icon-detail icon-new-offer"
  }) : _vm._e(), _vm._v(" "), (_vm.isOfferPromotion) ? _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t('Product is on promotion') + ': ' + _vm.renderPromotion('name')),
      expression: "t('Product is on promotion') + ': ' + renderPromotion('name')",
      arg: "tooltip"
    }],
    staticClass: "offer-component icon icon-detail icon-promotions"
  }) : _vm._e(), _vm._v(" "), (_vm.isOfferPromotionCode) ? _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.renderPromotion('code')),
      expression: "renderPromotion('code')",
      arg: "tooltip"
    }],
    staticClass: "offer-component icon icon-detail icon-promotion-code"
  }) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getOfferLink,
      "rel": "noreferrer"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getOfferPrice))])]), _vm._v(" "), _c('span', {
    staticClass: "strikethrough-price"
  }, [_vm._v(_vm._s(_vm.getOfferStrikeThroughPrice))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getPricePercentDiff) ? _c('span', {
    style: ({
      color: _vm.getColor
    })
  }, [_c('small', [_vm._v("(" + _vm._s(_vm.getPricePercentDiff) + "%)")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c468dd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/OfferComponent.vue
// module id = 1275
// module chunks = 2